import React from "react";
import styled from "styled-components";
import {timeBetween} from "../../idea/timeOpenCalculator";
import {useSelector} from "react-redux";
import {Clock, Instant} from "js-joda";

const PortfolioMessageContainer = styled.div`    
    color: #FFFFFF;
    background: #4A4A4A;
    font-size: 12px;
    line-height: 14px;
    padding: 9px 18px;
`;

const MetaData = styled.span`
    font-style: italic;
    color: #d8d8d8;
`;

export const PortfolioMessage = ({portfolioMessage}) => {
    const clock = useSelector(({clock}) => clock || Clock.systemDefaultZone());

    if (!portfolioMessage) {
        return null;
    }
    const now = Instant.now(clock).toString();
    const expiry = portfolioMessage.expiration + "T23:59:59Z";
    return (
        <PortfolioMessageContainer className="t-message">
            <MetaData>{portfolioMessage.author} says:</MetaData> {portfolioMessage.message} <MetaData>Expires in {timeBetween(now, expiry, clock)}</MetaData>
        </PortfolioMessageContainer>
    );
};
